export default __webpack_public_path__ + "static/redwax-b3372f43b3ab04455b4b04cabbe6ead6.png";